import scrollToElement from 'scroll-to-element';
import Axios from 'core/axios';
import Validation from 'core/validation';
import Rest from 'core/rest';
import { i18n } from 'core/i18n';
import {
	openMask,
	closeMask,
	openError
} from '../mainModule/action';

export const APPLICATION_INIT_SUCCESS = 'APPLICATION_INIT_SUCCESS';
export const APPLICATION_CLEAR = 'APPLICATION_CLEAR';
export const APPLICATION_POST_MAINAGENT_SUCCESS = 'APPLICATION_POST_MAINAGENT_SUCCESS';
export const APPLICATION_UPDATE_AGENT_INFO = 'APPLICATION_UPDATE_AGENT_INFO';
export const APPLICATION_POST_ERROR = 'APPLICATION_POST_ERROR';
export const APPLICATION_CLEAR_ERROR = 'APPLICATION_CLEAR_ERROR';

export function initApplication() {
	return (dispatch) => {
		return dispatch({
			type: APPLICATION_INIT_SUCCESS
		});
  };
}

export function clearApplication() {
	return (dispatch) => {
		return dispatch({
			type: APPLICATION_CLEAR
		});
	};
}

export function postMainAgent(data) {
	return (dispatch) => {
		// 清空所有錯誤
		dispatch({
			type: APPLICATION_CLEAR_ERROR
		});

		// 欄位驗證
		const errors = Validation.validateAgentInfo(data);
		
		// confirm check (email)
		if (data && data.confirmEmail !== data.email) {
			errors.confirmEmail = i18n('error_confirm_email');
		}
		// confirm check (password)，有修改密碼才需檢核
		if (data && data.hasOwnProperty('password') && data.confirmPassword !== data.password) {
			errors.confirmPassword = i18n('error_confirm_password');
		}

		if (!data.agreementChecked) {
			errors.agreementChecked = i18n('error_agreement');
		}

		if (errors && JSON.stringify(errors) !== '{}') {
			// 視窗滾動至最上方錯誤欄位
			let scrollTo = null;
			if (errors.organizationCode) {
				// 滾動至登入資訊區塊
				scrollTo = 'login';
			} else if (errors.preferredCurrency || errors.preferredLanguage) {
				// 滾動至設定區塊
				scrollTo = 'setting';
			} else if (errors.title || errors.firstName || errors.lastName
				|| errors.mobilePhone || errors.workPhone || errors.email || errors.confirmEmail) {
				// 滾動至聯絡人詳細資訊區塊
				scrollTo = 'contact';
			} else if (errors.address1 || errors.city || errors.addressState || errors.country) {
				// 滾動至地址區塊
				scrollTo = 'address';
			}
			
			if (scrollTo) {
				scrollToElement(`.application-panel.${scrollTo}`, {
					offset: -100,
					ease: 'out-circ',
					duration: 1500
				});
			}

			// 驗證失敗，顯示錯誤
			return dispatch({
				type: APPLICATION_POST_ERROR,
				errors
			});
		} else {
			// 驗證成功，打登入API
			dispatch(openMask());
			
			let requestData = JSON.parse(JSON.stringify(data));
			
			// 拔除多餘key
			if (requestData.confirmEmail) delete requestData.confirmEmail;
			if (requestData.confirmPassword) delete requestData.confirmPassword;
			if (requestData.agreementChecked) delete requestData.agreementChecked;

			// 若電話第一碼為0，需拔除第一碼0
			requestData.mobilePhone.number = (requestData.mobilePhone.number).replace(/^([0]*)([1-9]+[0-9]+)$/, '$2');
			requestData.workPhone.number = (requestData.workPhone.number).replace(/^([0]*)([1-9]+[0-9]+)$/, '$2');
			
			return Axios.post(Rest.agent.postMainAgent(), requestData)
				.then(() => {
			   	dispatch(closeMask());
					return dispatch({
						type: APPLICATION_POST_MAINAGENT_SUCCESS
					});
				})
				.catch((error) => {
					dispatch(closeMask());
					return dispatch(openError(error));
				});
		}
  };
}

export function updateAgentInfo(data) {
	return (dispatch) => {
		dispatch({
			type: APPLICATION_UPDATE_AGENT_INFO,
			data
		});
	};
}